import { Icon } from '../../../components/icons'
import { Column } from '../../../components/layouts/columns'
import { Page } from '../../../components/layouts/page'
import { Button } from '../../../components/ui/button'
import { Checkbox } from '../../../components/ui/checkbox'
import { Form } from '../../../components/ui/form'
import { Input } from '../../../components/ui/input'
import { PaginationFunctional } from '../../../components/ui/pagination/PaginationFunctional'
import { Select } from '../../../components/ui/select'
import { Table } from '../../../components/ui/table'
import { PathDoc } from '../../../router/docs'
import { DataComTraçoParaDataComBarra } from '../../../utils/dates'
import { TransformationforMask } from '../../../utils/masks'
import { useClientEventsStaff } from './_hooks/useClientEventsStaff'
import { ModalAddCandidates } from './_modal/modalAddCandidates'
import { ModalInfoCandidacy } from './_modal/modalInfoCandidacy'
import { ModalInviteCandidates } from './_modal/modalInviteCandidates'
import { ModalRegisterWorkingHours } from './_modal/modalRegisterWorkingHours'
import { ModalUploadPayment } from './_modal/modalUploadPayment'
import { HandleExportSpreadsheet } from './_spreadsheets/exportSpreadSheet'
import { ActionsOfCandidates } from './_utils/actionsOfCandidates'
import { StatusCandidate } from './_utils/statusCandidate'
// import { Button } from '../../../components/ui/button'
// import { Path } from '../../../router/paths'

export const ClientEventsStaff = () => {
  const {
    id,
    user,
    clientId,
    page,
    setPage,
    loading,
    setLoading,
    setAlerts,
    filter,
    setFilter,
    checks,
    setChecks,
    checkAll,
    setCheckall,
    infosContext,
    dataContext,
    formContext,
    setFormContext,
    FetchGetInfos,
    FetchGetdatas,
    FetchClearQueryData,
    ActionForButtonsCandidates,
    ActionForButtonsMultiplesCandidates,
    modalInvite,
    setModalInvite,
    modalInfoCandidacy,
    setModalInfoCandidacy,
    modalUploadPayments,
    setModalUploadPayments,
    ActionForModalInfoColaborator,
    HandleUpdateValuesInfoCandidacy,
    // exportAllData,
    // criar1000Candidaturas,
    teamsList,
    HandleInviteTeams,
    HandleExportExcelPayment,
    HandleReadSheetPayment,
    modalRegisterWorkingHours,
    setModalRegisterWorkingHours,
    HandleAddWorkingHours,
    HandleDeleteWorkingHours,
    // HandleExportAllWorkingTimeRegister,
    modalAdd,
    setModalAdd,
    HandleGetDataFavorites,
    searchFavorite,
    setSearchFavorite,
    HandleAddCandidacy,
    dataStaffFiltered,
    handleFilter,
    showFilters,
    setShowFilters,
    filterConfigs,
    getFilterLabel,
  } = useClientEventsStaff()

  return (
    <div>
      <ModalInfoCandidacy
        setActive={setModalInfoCandidacy}
        active={modalInfoCandidacy}
        values={formContext}
        actions={ActionForModalInfoColaborator()}
        infosContext={infosContext}
      ></ModalInfoCandidacy>
      <ModalInviteCandidates
        setActive={setModalInvite}
        active={modalInvite}
        formContext={formContext}
        setFormContext={setFormContext}
        infosContext={infosContext}
        HandleInviteTeams={HandleInviteTeams}
      ></ModalInviteCandidates>
      <ModalAddCandidates
        setActive={setModalAdd}
        active={modalAdd}
        formContext={formContext}
        setFormContext={setFormContext}
        search={searchFavorite}
        setSearch={setSearchFavorite}
        infosContext={infosContext}
        dataContext={dataContext}
        loading={loading}
        actions={{
          searchFavorite: () => {
            HandleGetDataFavorites()
          },
          add: async (values) => {
            await HandleAddCandidacy(values)
          },
        }}
      ></ModalAddCandidates>
      <ModalRegisterWorkingHours
        setActive={() => {
          setModalRegisterWorkingHours(false)
          setFormContext((prev) => ({ ...prev, CandidacyRegisterWorkingHours: '' }))
        }}
        active={modalRegisterWorkingHours}
        formContext={formContext}
        setFormContext={setFormContext}
        loading={loading}
        infosContext={infosContext}
        teamsList={teamsList}
        actions={{
          submit: () => {
            HandleAddWorkingHours()
          },
          delete: (values) => {
            HandleDeleteWorkingHours(values)
          },
        }}
      ></ModalRegisterWorkingHours>
      <ModalUploadPayment
        setActive={setModalUploadPayments}
        active={modalUploadPayments}
        formContext={formContext}
        setFormContext={setFormContext}
        loading={loading}
        actions={{
          submit: () => {
            HandleReadSheetPayment()
          },
          download: () => {
            HandleExportExcelPayment()
          },
        }}
      ></ModalUploadPayment>

      {(!modalInfoCandidacy || !modalInvite || !modalRegisterWorkingHours || !modalUploadPayments) && (
        <>
          <Page.Section className="is-fullheight-with-navbar mt-6 mx-3" style={{ minHeight: '70vh' }}>
            <Column.Root>
              {/* Titulo da pagina */}
              <Column.Content>
                <p className="subtitle is-size-4">
                  <Icon size={30} className={'mr-3'}>
                    users
                  </Icon>
                  Staff
                </p>
              </Column.Content>

              {/* Botões superiores */}
              <Column.Content className="has-text-right">
                <Button.Root align="right">
                  <Button.Content>
                    <Button.A className={'mt-3'} link={PathDoc.EventStaff} openNew color="is-light" loading={loading}>
                      Tutorial
                    </Button.A>
                  </Button.Content>

                  <Button.Dropdown.Root>
                    <Button.Dropdown.Button
                      color="is-light"
                      colorText="has-text-success"
                      loading={loading}
                      title={'Exportar Staff'}
                      titleBehind="Exportar Staff"
                    >
                      <Icon size={25} margin={-5} className="mr-2">
                        users
                      </Icon>
                      <Icon size={25} margin={-5}>
                        checkin
                      </Icon>
                    </Button.Dropdown.Button>

                    <Button.Dropdown.OptionContent>
                      {(infosContext?.reportsGlobal || []).map((report, index) => {
                        return (
                          <Button.Dropdown.Option
                            key={`reportGlobal-${index}`}
                            action={async () => {
                              if (!user.user.permissions.staffEvent_exportSheets) {
                                return setAlerts((prev) => [
                                  ...prev,
                                  {
                                    type: 'error',
                                    title: 'Permissão Negada',
                                    msg: 'Você não possui permissão para realizar essa ação.',
                                  },
                                ])
                              }

                              await HandleExportSpreadsheet(clientId, report.id, 'global', id, setLoading, setAlerts)
                              return null
                            }}
                          >
                            {report.name}
                          </Button.Dropdown.Option>
                        )
                      })}
                      <Button.Dropdown.Divider />
                      {(infosContext?.myReports || []).map((report, index) => {
                        return (
                          <Button.Dropdown.Option
                            key={`myReports-${index}`}
                            action={async () => {
                              await HandleExportSpreadsheet(clientId, report.id, 'client', id, setLoading, setAlerts)
                            }}
                          >
                            {report.name}
                          </Button.Dropdown.Option>
                        )
                      })}
                    </Button.Dropdown.OptionContent>
                  </Button.Dropdown.Root>

                  <Button.Content>
                    <Button.Bt
                      className=""
                      color="is-light"
                      loading={loading}
                      title={'Adicionar Marcação de pontos'}
                      titleBehind="Marcações de pontos"
                      action={() => {
                        setModalRegisterWorkingHours(true)
                        setFormContext((prev) => ({ ...prev, CandidacyRegisterWorkingHours: 'all' }))
                      }}
                      isHidden={formContext.statusEvent === 'closed'}
                    >
                      <Icon size={25} margin={-5} className="mr-2">
                        history
                      </Icon>
                      +
                    </Button.Bt>
                  </Button.Content>

                  <Button.Content>
                    <Button.Bt
                      className=""
                      color="is-success"
                      colorText="has-text-white"
                      loading={loading}
                      title={'Enviar Convite'}
                      titleBehind="Enviar Convite"
                      action={() => {
                        setModalAdd(true)
                      }}
                      isHidden={formContext.statusEvent === 'closed'}
                    >
                      +<Icon size={18}>user</Icon>
                    </Button.Bt>
                  </Button.Content>
                  <Button.Content>
                    <Button.Bt
                      className=""
                      color="is-light"
                      loading={loading}
                      title="Importar Pagamentos"
                      action={() => {
                        setModalUploadPayments(true)
                      }}
                      isHidden={formContext.statusEvent === 'open'}
                      titleBehind="Importar Pagamentos"
                    >
                      <Icon size={25} margin={-5} className="mr-2">
                        bill
                      </Icon>
                      <Icon size={25} margin={-5}>
                        checkout
                      </Icon>
                    </Button.Bt>
                  </Button.Content>

                  <Button.Content>
                    <Button.Bt
                      color="is-dark"
                      colorText="has-text-white"
                      action={async () => {
                        FetchGetInfos()
                        FetchGetdatas()
                      }}
                      loading={loading}
                      titleBehind="Atualizar"
                    >
                      <Icon size={20} margin={-1}>
                        sync
                      </Icon>
                    </Button.Bt>
                  </Button.Content>
                </Button.Root>
              </Column.Content>
            </Column.Root>

            <Column.Root>
              <Column.Content>
                <p className="subtitle has-text-grey-light">{TransformationforMask(formContext.name, 'title')}</p>
              </Column.Content>
            </Column.Root>
            {dataContext?.staff ? (
              <>
                <>
                  {/* Pesquisar */}
                  <Form.Root action={async () => await handleFilter()}>
                    <Column.Root className="is-mobile">
                      <Column.Content>
                        <Input.Root>
                          <Input.Contents alignIcon={'left'}>
                            <Input.Prompt
                              value={filter}
                              setValue={setFilter}
                              field={'search'}
                              placeholder="Pesquisar..."
                            ></Input.Prompt>
                            <Input.Icon align="is-left">
                              <Icon size={20}>search</Icon>
                            </Input.Icon>
                          </Input.Contents>
                        </Input.Root>
                      </Column.Content>
                    </Column.Root>
                  </Form.Root>

                  {/* Filtros da pagina */}
                  <div className="box my-2">
                    <div className="is-flex is-justify-content-space-between is-align-items-center mb-2">
                      <Input.Label className="has-text-grey mb-0">Filtros</Input.Label>
                      <button
                        className="button is-small is-rounded is-light"
                        type="button"
                        onClick={() => setShowFilters(!showFilters)}
                      >
                        {showFilters ? 'Esconder' : 'Mostrar'}
                      </button>
                    </div>

                    {showFilters ? (
                      <Column.Root className="ml-2 is-multiline">
                        {filterConfigs.map(({ label, field, options, type }) => {
                          const optsWithTodos = [{ value: 'todos', label: 'Todos' }, ...(options || [])]
                          return (
                            <Column.Content size="is-6" key={field} style={{ marginBottom: 8 }}>
                              <Input.Root>
                                <Input.Label className="ml-3 has-text-grey-light is-size-7" style={{ marginBottom: 0 }}>
                                  {label}
                                </Input.Label>
                                {type === 'selectSearch' && (
                                  <Select.Root>
                                    <Select.Search
                                      color="is-grey"
                                      className="is-fullwidth is-rounded is-small"
                                      value={filter}
                                      setValue={setFilter}
                                      field={field}
                                      options={optsWithTodos}
                                    />
                                  </Select.Root>
                                )}
                                {type === 'selectSearchMulti' && (
                                  <Select.Root>
                                    <Select.SearchMulti
                                      color="is-grey"
                                      className="is-fullwidth is-rounded is-small"
                                      value={filter}
                                      setValue={setFilter}
                                      field={field}
                                      options={optsWithTodos}
                                    />
                                  </Select.Root>
                                )}
                              </Input.Root>
                            </Column.Content>
                          )
                        })}

                        <Column.Content style={{ marginTop: 8 }}>
                          <Button.Root align="is-right">
                            <Button.Content>
                              <Button.Bt
                                className="mt-2 is-rounded"
                                color="is-light"
                                size="is-small"
                                loading={loading}
                                title="Limpar"
                                type="button"
                                action={() => FetchClearQueryData()}
                              >
                                Limpar
                              </Button.Bt>
                            </Button.Content>
                            <Button.Content>
                              <Button.Bt
                                className="mt-2 is-rounded"
                                color="is-dark"
                                size="is-small"
                                loading={loading}
                                title="Filtrar"
                                type="button"
                                action={() => handleFilter()}
                              >
                                Filtrar
                              </Button.Bt>
                            </Button.Content>
                          </Button.Root>
                        </Column.Content>
                      </Column.Root>
                    ) : (
                      <div className="tags are-medium mt-2">
                        {Object.entries(filter).map(([key, value]) => {
                          if (value && key !== 'search' && value !== 'todos') {
                            const label = getFilterLabel(key, value)
                            return (
                              <span key={key} className="tag is-dark is-light mr-1 mb-1">
                                {label}
                              </span>
                            )
                          }
                          return null
                        })}
                      </div>
                    )}
                  </div>
                </>

                <Column.Root className={'mt-5'}>
                  {/* Ações quando checkbox é chegacado */}

                  {formContext?.statusEvent === 'open' &&
                  Object.values(checks).filter((check) => check === true).length > 0 ? (
                    <Column.Content className="box ">
                      <Input.Label className="has-text-grey-light is-size-7 mb-2" style={{ marginBottom: 0 }}>
                        Colaboradores selecionados: [ {Object.values(checks).filter((check) => check === true).length} ]
                      </Input.Label>
                      <ActionsOfCandidates
                        loading={loading}
                        status={Number(filter?.status)}
                        align="left"
                        actions={ActionForButtonsMultiplesCandidates(checks)}
                      ></ActionsOfCandidates>
                    </Column.Content>
                  ) : (
                    <Column.Content></Column.Content>
                  )}

                  {/* Contagem de candidaturas */}
                  <Column.Content className="has-text-right">
                    <p>
                      {'Staff Filtrado:  '}
                      <Icon size={20} className={'mx-2'}>
                        filter
                      </Icon>
                      {(dataStaffFiltered || []).length}
                    </p>
                  </Column.Content>
                  <Column.Content className="has-text-right">
                    <p>
                      {'Staff Total:  '}
                      <Icon size={20} className={'mx-2'}>
                        users
                      </Icon>
                      {(dataContext.staff.data || []).length}
                    </p>
                  </Column.Content>
                </Column.Root>

                {/* Lista de Staff */}
                {dataContext?.staff?.data.length > 0 ? (
                  <Column.Root className="is-mobile box my-2">
                    <Column.Content>
                      <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                        <Table.Head>
                          <Table.Row key={'table_events_head'}>
                            <Table.Cell size={20}>
                              <Checkbox.Root>
                                {(() => {
                                  const arr = Array.isArray(filter?.status)
                                    ? filter.status
                                    : [filter?.status].filter(Boolean)

                                  return arr.length === 1 ? (
                                    <Checkbox.Content value={checkAll} setValue={setCheckall} />
                                  ) : null
                                })()}
                              </Checkbox.Root>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>Data</Table.Cell>
                            <Table.Cell>Turno</Table.Cell>
                            <Table.Cell>Vaga</Table.Cell>
                            <Table.Cell>Nome</Table.Cell>
                            <Table.Cell size={150}>CPF</Table.Cell>
                            <Table.Cell size={20}>Avaliação</Table.Cell>
                            <Table.Cell size={100}>Cidade/Estado</Table.Cell>
                            <Table.Cell>Status</Table.Cell>
                            {formContext?.statusEvent === 'open' && <Table.Cell size={200}>Ações</Table.Cell>}
                          </Table.Row>
                        </Table.Head>
                        <Table.Body>
                          {dataStaffFiltered.slice(0, 100).map((value) => {
                            return (
                              <>
                                <Table.Row key={value.id}>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    <Checkbox.Root>
                                      {(() => {
                                        const arr = Array.isArray(filter?.status)
                                          ? filter.status
                                          : [filter?.status].filter(Boolean)

                                        return arr.length === 1 && arr.includes(String(value.status)) ? (
                                          <Checkbox.Content
                                            key={`check-${value.id}`}
                                            value={checks}
                                            setValue={setChecks}
                                            field={value.id}
                                          ></Checkbox.Content>
                                        ) : null
                                      })()}
                                    </Checkbox.Root>
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    <Button.Content>
                                      <Button.Bt
                                        colorText={'has-text-white'}
                                        color="is-warning"
                                        action={() => {
                                          HandleUpdateValuesInfoCandidacy(value)
                                        }}
                                        loading={loading}
                                        title="Aceitar Candidatura"
                                        titleBehind="Informações"
                                      >
                                        <Icon size={20} margin={-5}>
                                          user
                                        </Icon>
                                      </Button.Bt>
                                    </Button.Content>
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    {DataComTraçoParaDataComBarra(value?.jobOffer?.date)}
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">{value?.jobOffer?.round}</Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    {value?.jobOffer?.position?.nome || value?.jobOffer?.position?.name}
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    {TransformationforMask(value.name, 'title')}
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">{value.cpf}</Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    {value?.collabData?.positions?.[value?.jobOffer?.idPosition]?.score || '0.00'}
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    {value?.collabData?.address?.city + ' - ' + value?.collabData?.address?.state}
                                  </Table.Cell>
                                  <Table.Cell className="is-size-7 is-vcentered">
                                    {StatusCandidate(value.status)}
                                  </Table.Cell>
                                  {formContext?.statusEvent === 'open' && (
                                    <Table.Cell className="is-vcentered">
                                      <div className="mt-2">
                                        <ActionsOfCandidates
                                          loading={loading}
                                          status={Number(value.status)}
                                          align="centered"
                                          actions={ActionForButtonsCandidates(value)}
                                        ></ActionsOfCandidates>
                                      </div>
                                    </Table.Cell>
                                  )}
                                </Table.Row>
                              </>
                            )
                          })}
                        </Table.Body>
                      </Table.Root>
                    </Column.Content>
                  </Column.Root>
                ) : (
                  <p className="has-text-centered mt-6">Ops, Nenhuma candidatura encontrada</p>
                )}
              </>
            ) : (
              <Column.Root>
                <Column.Content></Column.Content>
                <Column.Content>
                  <Icon>loading</Icon>
                </Column.Content>
                <Column.Content></Column.Content>
              </Column.Root>
            )}
          </Page.Section>
          <PaginationFunctional
            paginationData={dataContext?.staff?.pagination}
            valuePage={page}
            setValuePage={setPage}
            setFetchData={() => {
              FetchGetdatas()
              FetchGetInfos()
            }}
          ></PaginationFunctional>
        </>
      )}
    </div>
  )
}
